var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("FilePreviewer", {
        staticClass: "full-preview",
        attrs: {
          "file-list": _vm.parsedFiles,
          loading: false,
          "app-name": _vm.appName,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }